export default function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_arrayFromIterator.js
// module id = 2115
// module chunks = 0